import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import useBeacon from "../../application/hooks/useBeacon";
import { beaconSelector } from "../../application/recoil/selector";
import { PAGE_NM } from "../../application/types/types";

import { useParams } from "react-router-dom";
import useNav from "../../application/hooks/useNav";
import Survey from "../etc/Survey/Survey";

const ServiceAnswer = () => {
    const params = useParams();
    const { historyBack } = useNav();
    const beaconData = useRecoilValue(beaconSelector);
    const beacon = useBeacon({
        mediaCd: beaconData.mediaCd,
        custSeq: beaconData.custSeq,
        srcCd: beaconData.srcCd,
        pageName: PAGE_NM.SURVEY,
    });

    useEffect(() => {
        beacon.sendViewPage();
    }, []);

    const goToPrevious = () => {
        historyBack();
    }

    return (
        <Survey surveyType={params.surveyType ?? "mgt_pre_req"} 
                targetSeq={params.targetSeq} isBottomSheet={false} 
                onSave={goToPrevious} />  
    );
}

export default ServiceAnswer;